import * as React from 'react';

import Icon from './Icon';
import {IconProps} from './type';
import {Path} from 'react-native-svg';

const BarcodeIcon: React.FC<IconProps> = props => {
  return (
    <Icon viewBox="0 0 16 16" height={22} width={22} {...props} fill="none">
      <Path fill={props.fill} d="M0 3h1v10h-1v-10z" />
      <Path fill={props.fill} d="M8 3h2v10h-2v-10z" />
      <Path fill={props.fill} d="M11 3h1v10h-1v-10z" />
      <Path fill={props.fill} d="M13 3h1v10h-1v-10z" />
      <Path fill={props.fill} d="M15 3h1v10h-1v-10z" />
      <Path fill={props.fill} d="M2 3h3v10h-3v-10z" />
      <Path fill={props.fill} d="M6 3h1v10h-1v-10z" />
    </Icon>
  );
};

export default React.memo(BarcodeIcon);
